import { Component, Input } from 'angular-ts-decorators';

/**
 * Component that displays a page.
 * Has a passable binding called isColumnar which allows the flow of the page
 * to become columnar vs row.
 *
 * # Example
 * <pre>
 *   <sw-page is-columnar="true"></sw-page>
 * </pre>
 */
@Component({
  selector: 'swPage',
  transclude: true,
  template: require('./sw-page.html').default,
})
export class SwPageComponent {
  @Input() isColumnar: boolean;
  constructor() {
    'ngInject';
  }
}
